import { Tooltip } from '@mui/material'
import { withStyles } from 'tss-react/mui'

const IconTooltip = withStyles(Tooltip, {
  tooltip: {
    fontSize: '1em',
    padding: '7px',
  },
})

export default IconTooltip
